import { useParams } from "react-router-dom";
import { HublinkHead, TeiHubLinkCancelledOrders } from "../components";

export function TeiHubLinkCancelled() {
  const { clientType } = useParams();

  return (
    <>
      <HublinkHead
        HublinkBreadCrumbsProps={{
          home: {
            title: "Cancelled Orders",
            url: `/hublink/cancelled/${clientType}`,
          },
          className: "lg:h-[200px]",
          pageTitles: [],
        }}
      />
      <div className="p-3">
        <TeiHubLinkCancelledOrders />
      </div>
    </>
  );
}
